import React from 'react';
import Tooltip from 'antd/es/tooltip';
import { TFunction } from 'i18next';
import {
  Flex,
  RowActionButton,
  capitalizeFirstLetter,
} from '@mss/mss-component-library';
import { Copy } from 'react-feather';
import StatusCircle from 'jsx/common/StatusCircle';

const columns = (t: TFunction, openDetailModal: (x: any) => void) => [
  {
    dataIndex: 'state',
    title: t('State'),
    render: (state: string) => (
      <StatusCircle
        size={8}
        text={{
          data: String(capitalizeFirstLetter(state)),
          hideUnavailable: true,
          italic: true,
        }}
      />
    ),
  },
  {
    title: t('Message'),
    dataIndex: 'message',
    key: 'message',
    width: 265,
  },
  {
    title: t('Asset / Application'),
    dataIndex: ['attributes', 'asset', 'data', 'name'],
    key: ['attributes', 'asset', 'data', 'name'].join('.'),
    width: 265,
    render: (record: any) => (record ? record : t('N/A')),
  },
  {
    title: '',
    dataIndex: '',
    key: 'actions',
    width: 40,
    render: (record: any) => {
      return (
        record && (
          <Flex onClick={e => e.stopPropagation()}>
            <Tooltip title={t('Show details')}>
              <RowActionButton
                onClick={() => openDetailModal(record)}
                shape="circle"
                style={{ border: 'none', backgroundColor: 'transparent' }}
              >
                <Copy size={18} className="text-gray-500" />
              </RowActionButton>
            </Tooltip>
          </Flex>
        )
      );
    },
  },
];

export default columns;
